module.exports = __webpack_public_path__ + "static/media/boat-img-29.5a3155eb.jpg";